import type {
    SearchCommerceProductsRequest,
    SearchCommerceProductsResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const searchCommerceProductsOperation = defineCommerceOperation<
    SearchCommerceProductsRequest,
    SearchCommerceProductsResponse
>("commerce.products.search");
